import React from 'react';
import clsx from 'clsx';
import * as styles from './Button.module.scss';

const Button = React.forwardRef((props, ref) => {
  const {
    type = 'button',
    className,
    variant,
    disabled = false,
    ...other
  } = props;

  return (
    <button
      ref={ref}
      type={type}
      className={clsx(styles[`btn${variant.charAt(0).toUpperCase() + variant.slice(1)}`], className)}
      disabled={disabled}
      {...other}
    />
  );
});

export default React.memo(Button);